module.exports = __webpack_public_path__ + "img/branderbox-logo.876adf8e.png";